import { StateModel } from '../../../../redux/store';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Button from '../../../../components/button/Button';
import Table from '../../../../components/table/Table';
import { initBerechnteileTableConfig } from './BerechnteileTableConfig';
import { removeNotifications } from '../../../../utils/notificationUtils';
import { setModalConfig } from '../../../../redux/actions/modal';
import { initBerechnteilposTableConfig } from './BerechnteilposTableConfig';
import { getBerechnteile } from '../../../../redux/actions/auftrag';
import { utcIsoDateToLocaleDateAndTimeAndDay } from '../../../../utils/date';

interface PreisanzeigeProps {
  auftragserfassung: any;
  close: () => void;
  setModalConfig: (value: any, fieldName: string) => void;
  getBerechnteile: (auftragId: number) => void;
}
const Preisanzeige = (props: PreisanzeigeProps) => {
  const [tableConfigBrt, setTableConfigBrt] = useState(
    initBerechnteileTableConfig()
  );

  const [brt, setBrt] = useState([]);
  const [selectedRowBrt, setSelectedRowBrt] = useState<number | undefined>(
    undefined
  );
  const [tableConfigBrtPos, setTableConfigBrtPos] = useState(
    initBerechnteilposTableConfig()
  );
  const [brtPos, setBrtPos] = useState([]);
  const [selectedRowBrtPos, setSelectedRowBrtPos] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    initModal();
    removeNotifications();
    props.getBerechnteile(props.auftragserfassung.id);
  }, []);

  useEffect(() => {
    const formattedBrt = props.auftragserfassung.berechnteile;

    for (const b of formattedBrt) {
      b.leistungsDatum = utcIsoDateToLocaleDateAndTimeAndDay(b.leistungsDatum);
      b.betrag = b.betrag == null ? '' : parseFloat(b.betrag).toFixed(2);
      b.ertrag = b.ertrag == null ? '' : parseFloat(b.ertrag).toFixed(2);
    }

    setBrt(formattedBrt /*props.auftragserfassung.berechnteile*/);
    if (brt.length > 0) {
      setSelectedRowBrt(0);
    }
  }, [props.auftragserfassung.berechnteile]);

  useEffect(() => {
    if (
      selectedRowBrt != undefined &&
      (selectedRowBrt < brt.length - 1 || selectedRowBrt == 0)
    ) {
      const formattedBrtPos =
        props.auftragserfassung.berechnteile[selectedRowBrt ?? 0]
          .berechnteilpositionen;

      for (const bp of formattedBrtPos) {
        bp.betrag = bp.betrag == null ? '' : parseFloat(bp.betrag).toFixed(2);
        bp.satz = bp.satz == null ? '' : parseFloat(bp.satz).toFixed(2);
      }

      setBrtPos(formattedBrtPos);
    } else {
      setBrtPos([]);
    }
  }, [selectedRowBrt]);

  const initModal = () => {
    props.setModalConfig('Tagespreis Anzeige', 'title');
    props.setModalConfig('690px', 'height');
    props.setModalConfig('90%', 'width');
  };

  const close = () => {
    props.close();
  };

  return (
    <div className={'wrapper-preisanzeige'}>
      <div className='wrapper-form'>
        <div className={'wrapper-preisanzeige-table'}>
          <label>Berechnung</label>
          <Table
            tableConfig={tableConfigBrt}
            name={'Abrechnungsbereich'}
            setTableConfig={setTableConfigBrt}
            data={brt}
            setData={setBrt}
            tabSkipIndices={[0]}
            selectByAllTablecells={true}
            selectedRow={selectedRowBrt}
            setSelectedRow={setSelectedRowBrt}
          />
          <label>Positionen der Berechnung</label>

          <Table
            tableConfig={tableConfigBrtPos}
            name={'Abrechnungsposition'}
            setTableConfig={setTableConfigBrtPos}
            data={brtPos}
            setData={setBrtPos}
            tabSkipIndices={[0]}
            selectByAllTablecells={true}
            selectedRow={selectedRowBrtPos}
            setSelectedRow={setSelectedRowBrtPos}
          />

          <div className={'buttonpair'}>
            <Button
              tooltip='Ok, danke'
              classes={'iconButton'}
              key={1}
              onClickHandler={() => close()}
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
});

export default connect(mapStateToProps, {
  setModalConfig,
  getBerechnteile,
})(Preisanzeige);
